import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetPropertyTypeResponseTO } from 'models/PropertyType';
import API from 'services/API';

export const PROPERTY_TYPES_BASE_QUERY_KEY = 'property-types';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetPropertyTypeResponseTO>,
  'queryKey' | 'queryFn'
>;

const useFetchPropertyTypes = ({
  enabled,
  ...options
}: ReactQueryOptions = {}) => {
  return useAppQuery({
    // @ts-expect-error TS2769 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    queryKey: [PROPERTY_TYPES_BASE_QUERY_KEY],
    queryFn: async () => {
      const response = await API.get<GetPropertyTypeResponseTO>(
        '/api/internal/properties/types',
      );
      return response.data;
    },
    staleTime: 30000,
    keepPreviousData: true,
    enabled: enabled !== undefined ? enabled : true,
    ...(options ?? {}),
  });
};

export default useFetchPropertyTypes;
